export const CHECKBOX_SIZE_DEFAULT = 'default';
export const CHECKBOX_SIZE_BIG = 'big';

export const CHECKBOX_SIZES = [
    CHECKBOX_SIZE_DEFAULT,
    CHECKBOX_SIZE_BIG,
];
